import type { FaireProductEntity } from "../../entity_types/product";

export const p_eaksjtewmq: FaireProductEntity = {
  token: "p_eaksjtewmq",
  type: "product",
  name: "Guava Rescue Spray",
  brandToken: "b_4240zqg5kc",
  brandName: "Ceremonia",
  imageUrl:
    "https://cdn.faire.com/fastly/3301513c54cfe8296ffe16ceed8555d3f483dbab97cbd5a8d02ee1b9aaf1327c.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=960&width=720",
  priceDollars: 15.75,
  description: "Guava Rescue Spray for wholesale.",
  tags: ["haircare"],
  caseSize: 6,
  msrpDollars: 31.5,
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-04-14T00:00:00.000Z",
    importedBy: "ceremonia-brand-prototype",
  },
  categoryTokens: [],
};
